import styled, { css } from 'styled-components';
import { colors } from 'assets/styled/tokens';
import { inputStyleFactory } from 'components/Form/shared/inputStyleFactory';

export const CalendarContainer = styled.div`
  width: 100%;
  min-width: 0;
  height: 100%;
  box-sizing: border-box;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  min-height: 70vh;
`;

export const CalendarToolBar = styled.div`
  width: 100%;
  box-sizing: border-box;
  border-radius: 8px 8px 0 0;
  border-bottom: none;
`;

export const ViewsButtonsContainer = styled.div`
  width: 100%;
  height: 60px;
  box-sizing: border-box;
  padding: 16px;
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
`;

export const ToolBarFirstRow = styled.div`
  width: 100%;
  height: 60px;
  display: flex;
  flex-direction: row;
`;

export const NavigateCalendarButtonsContainer = styled.div`
  flex-shrink: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const NavigationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  max-width: 250px;
`;

export const TipoboxWrapper = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0px;
  overflow: hidden;
`;

const TIPOBOX_GRAY_50 = '#FAF9F8';
const TIPOBOX_GRAY_200 = '#E8E1DE';
const SPACING_25 = 4;
const SPACING_50 = 8;

export const Tipobox = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${SPACING_50}px;
  height: 24px;
  max-width: 100%;
  min-width: 0;
  padding: ${SPACING_25}px ${SPACING_50}px;
  background: ${TIPOBOX_GRAY_50};
  border: 1px solid ${TIPOBOX_GRAY_200};
  border-radius: 4px;
  box-sizing: border-box;
  font-family: Roboto;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.3px;
  color: ${colors.carbon};
  overflow: hidden;
  svg {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    path {
      fill: ${colors.carbon};
    }
  }
`;

export const TipoboxText = styled.span`
  flex: 1;
  min-width: 0;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  strong {
    font-weight: 700;
  }
`;

export const FiltersButtonContainer = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 15px;
  justify-content: flex-end;
`;

export const FiltersContainer = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 16px;
  border-top: 1px solid #e5e5e5;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`;

export const FiltersGridWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  justify-content: center;
  min-width: 0;
`;
export const FiltersGridColumn = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FilterCell = styled.div`
  min-width: 0;
  display: flex;
  align-items: center;
`;

/** Força o campo Unidades (MultiSelectDropdown) a ter 24px de altura, alinhado aos botões ao lado */
export const UnidadesFieldWrapper = styled.div`
  width: 100%;
  height: 24px;
  min-height: 24px;
  max-height: 24px;
  & > div {
    height: 24px !important;
    min-height: 24px !important;
  }
  & > div > div:first-child {
    height: 24px !important;
    min-height: 24px !important;
    padding: 2px 8px;
  }
`;

export const TodayButton = styled.button`
  width: 46px;
  height: 24px;
  border: 1px solid ${colors.primary};
  color: ${colors.primary};
  background-color: #fff;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Roboto;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.3px;
`;

export const PrevNextButton = styled.button`
  height: 24px;
  width: 24px;
  border: none;
  cursor: pointer;
  svg {
    path {
      fill: ${colors.carbon};
    }
  }
`;

export const MonthYearContainer = styled.div`
  font-family: Roboto;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.3px;
  color: ${colors.carbon};
`;

export const FiltersButton = styled.button`
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px;
  font-family: Roboto;
  font-weight: 700;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0.5px;
  color: ${colors.carbon};
  min-width: 110px;
  height: 24px;
`;

export const TypeFilterContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const TypeButton = styled.button<{ isActive?: boolean; isRight?: boolean }>`
  height: 24px;
  min-height: 24px;
  max-height: 24px;
  min-width: 76px;
  padding: 2px 12px;
  font-family: Roboto;
  font-weight: ${({ isActive }) => (isActive ? '700' : '400')};
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.3px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ isActive }) =>
    isActive &&
    `
     border: 1px solid ${colors.carbon};
    `}
  ${({ isActive, isRight }) =>
    !isActive &&
    isRight &&
    `
     border: 1px solid ${colors.gray};
     border-left: none;
    `}
    ${({ isActive, isRight }) =>
    !isActive &&
    !isRight &&
    `
     border: 1px solid ${colors.gray};
     border-right: none;
    `}
  color: ${({ isActive }) => (isActive ? colors.carbon : colors.gray)};
  :first-of-type {
    border-radius: 4px 0 0 4px;
  }
  :last-of-type {
    border-radius: 0 4px 4px 0;
  }
`;

export const OpenModalButton = styled.button<{ width?: string; size?: string }>`
  border-radius: 4px;
  border: 1px solid #e5e5e5;
  background-color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  width: ${({ width }) => width};
  justify-content: space-between;
  overflow: hidden;
  font-weight: 400;
  color: ${colors.gray};
  font-size: 14px;
  gap: 10px;
  box-sizing: border-box;
  ${props => {
    const size = props.size || 'md';
    if (size === 'small' || size === 'sm') {
      return css`
        height: 24px;
        min-height: 24px;
        max-height: 24px;
        padding: 2px 12px;
      `;
    }
    return inputStyleFactory(size as any);
  }}
  div {
    display: flex;
    align-items: center;
    gap: 10px;
  }
`;

export const CalendarContentWrapper = styled.div`
  position: relative;
  min-height: 70vh;
  display: flex;
  flex-direction: column;
  width: 100%;

  & > * {
    width: 100%;
    min-width: 0;
  }
`;

export const CalendarLoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 0 0 8px 8px;
  z-index: 1;
`;

// Seta de navegação por dia – dentro do header da primeira/última coluna (Figma)
export const DayHeaderNavButton = styled.button<{ side: 'left' | 'right' }>`
  width: 24px;
  height: 40px;
  flex-shrink: 0;
  align-self: flex-start;
  border: 1px solid #e5e5e5;
  border-top: none;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 0;
  transition: background-color 0.15s ease;

  ${({ side }) =>
    side === 'left'
      ? 'margin-left: -4px; border-left: none; border-top-right-radius: none; border-bottom-right-radius: 4px;'
      : 'margin-right: -4px; border-right: none; border-top-right-radius: 4px; border-bottom-right-radius: none; border-bottom-left-radius: 4px;'}

  &:hover {
    background-color: #f5f3f1;
  }

  &:focus {
    outline: none;
  }

  svg {
    display: block;
  }
`;

// Componentes styled do WeekView
export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, minmax(100px, 1fr));
  width: 100%;
  min-height: 70vh;
  min-width: 0;
  box-sizing: border-box;
`;

const DROP_TARGET_BG = '#F5F3F1';
const DROP_TARGET_BORDER = '#DAD1CD';

export const DayContainer = styled.div<{
  isFirst?: boolean;
  isLast?: boolean;
  isHighlighted?: boolean;
  removeLeftBorder?: boolean;
  isWeekend?: boolean;
  isDropTarget?: boolean;
}>`
  min-width: 0;
  min-height: 150px;
  background-color: #fff;
  box-sizing: border-box;
  border-top: 1px solid #e5e5e5;
  border-left: 1px solid #e5e5e5;
  padding: 0;
  position: relative;
  ${({ isFirst }) =>
    isFirst &&
    `
      border-left: none;
      border-radius: 0 0 0 8px;
    `}

  ${({ isLast }) =>
    isLast &&
    `  border-right: none;
      border-radius: 0 0 8px 0;
    `}

  ${({ isHighlighted }) =>
    isHighlighted &&
    `
    border: 1px solid ${colors.primary};
  `}

  ${({ removeLeftBorder }) =>
    removeLeftBorder &&
    `
    border-left: none;
  `}
    ${({ isWeekend }) =>
    isWeekend &&
    `
    background-color: #FBFAF9 !important;
  `}

  ${({ isDropTarget }) =>
    isDropTarget &&
    `
    background: ${DROP_TARGET_BG};
    border: 1px solid ${DROP_TARGET_BORDER};
  `}
`;

export const DayColumnHeader = styled.div<{ $hasLeftArrow?: boolean; $hasRightArrow?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: ${({ $hasLeftArrow, $hasRightArrow }) =>
    $hasLeftArrow ? 'flex-start' : $hasRightArrow ? 'flex-end' : 'center'};
  padding: 0 4px 8px 4px;
  gap: 0;
  height: 48px;
  min-height: 48px;
  box-sizing: border-box;
`;

export const DayColumnHeaderContent = styled.div<{ $grow?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: ${({ $grow }) => ($grow ? '1' : '0 0 auto')};
  min-width: 0;
  padding-top: 8px;
`;

export const DayLabel = styled.label<{ isHighlighted?: boolean; isBlack?: boolean }>`
  font-family: Roboto;
  font-weight: 700;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0px;
  text-align: center;
  color: ${colors.gray};
  margin-bottom: 4px;
  ${({ isHighlighted }) =>
    isHighlighted &&
    `
    color: ${colors.darkPrimary};
  `}
  ${({ isBlack }) =>
    isBlack &&
    `
    color: ${colors.carbon};
  `}
`;

export const ExpectedHours = styled.div`
  font-family: Roboto;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0px;
  text-align: center;
  color: ${colors.gray};
`;

export const IsTodayLabel = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 33px;
  height: 16px;
  background-color: ${colors.primary};
  font-family: Roboto;
  font-weight: 700;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0px;
  color: ${colors.white};
  border-radius: 0 0 4px 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DayColumnBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  min-width: 0;
  padding: 0px 8px 24px 8px;
`;
